import axios from "axios";
import pinia from "@/pinia";
import { backend } from "@/assets/config/server";
import { useAccountStore } from "@/store/account";
import { initializeSession } from "@/services/auth";

const api = axios.create({
  baseURL: backend,

  withCredentials: true,
});

/*
|--------------------------------------------------------------------------
| Request
|--------------------------------------------------------------------------
*/

api.interceptors.request.use(
  async (config) => {
    const accountStore = useAccountStore(pinia);

    /*
     * Kalau belum pernah restore session,
     * coba refresh sekali.
     */

    if (!accountStore.initialized) {
      await initializeSession();
    }

    if (accountStore.accessToken) {
      config.headers.Authorization = `Bearer ${accountStore.accessToken}`;
    }

    return config;
  },

  (error) => Promise.reject(error),
);

/*
|--------------------------------------------------------------------------
| Response
|--------------------------------------------------------------------------
*/

api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const accountStore = useAccountStore(pinia);

    const originalRequest = error.config;

    /*
     * Token expired
     */

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const success = await initializeSession(true);

      if (success) {
        originalRequest.headers.Authorization = `Bearer ${accountStore.accessToken}`;

        return api(originalRequest);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
